module.exports = __webpack_public_path__ + "img/goldregen-2020-012.9f35c86c.jpg";